import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { CellType } from '../../types/Common';

import CustomTable from '../../components/UI/CustomTable';
import CustomPagination from '../../components/UI/CustomPagination';
import { TJobOffer } from '../../types/JobOffer';
import { getJobOffer } from '../../apis/job';
import ActionJobOfferHeader from '../../components/JobOffer/Action';

const tableHead = [
  {
    key: 'row',
    label: 'ردیف',
    type: CellType.ROW,
  },
  {
    key: 'title',
    label: 'عنوان',
    type: CellType.STRING,
  },
  {
    key: 'description',
    label: 'توضیحات',
    type: CellType.INFO,
  },
  {
    key: 'postedDate',
    label: 'تاریخ ایجاد',
    type: CellType.DATE,
  },
];

const JobOffer = () => {
  const [loading, setLoading] = useState(false);
  const [jobOfferSelected, setJobOfferSelected] = useState<number[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [jobOfferList, setJobOfferList] = useState<TJobOffer[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getJobOfferData = (id?: string) => {
    setLoading(true);
    getJobOffer(currentPage, rowsPerPage, id)
      .then((res: any) => {
        setJobOfferList(res.jobOffers || []);
        setTotalPages(res.pagination?.totalPages || 1);
      })
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getJobOfferData();
  }, [currentPage, rowsPerPage]);

  return (
    <Box className='mainUserContainer'>
      <ActionJobOfferHeader
        jobOfferSelected={jobOfferSelected}
        getJobOfferData={getJobOfferData}
        jobOfferList={jobOfferList}
        setJobOfferSelected={setJobOfferSelected}
      />

      <CustomTable
        rows={jobOfferList}
        tableHead={tableHead}
        selected={jobOfferSelected}
        setSelected={setJobOfferSelected}
        loading={loading}
        rowsIndex={rowsPerPage * (currentPage - 1)}
      />

      <CustomPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onChangeCurrentPage={(page: number) => setCurrentPage(page)}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={(rowsPerPage: number) => {
          if (currentPage !== 0) setCurrentPage(1);
          setRowsPerPage(rowsPerPage);
        }}
      />
    </Box>
  );
};

export default JobOffer;
